import {
  LocationGetAllResponse,
  CreateLocation,
  GetLocationResponse,
  LocationSearchParams,
  UpdateLocation,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class LocationApi {
  public createLocation = async (
    location: CreateLocation
  ): Promise<Partial<GetLocationResponse>> => {
    const result = await trpc.client.location.create.mutate(location);

    return result;
  };

  public getAllLocations = async (
    params: LocationSearchParams = {}
  ): Promise<LocationGetAllResponse> => {
    const result = await trpc.client.location.getAll.query(params);

    return result;
  };

  public getLocation = async (id: string): Promise<GetLocationResponse> => {
    const result = await trpc.client.location.getById.query({ id });

    return result;
  };

  public updateLocation = async (
    location: UpdateLocation
  ): Promise<Partial<GetLocationResponse>> => {
    const result = await trpc.client.location.update.mutate(location);

    return result;
  };
}
